import React from 'react'
import { SupplierManagementInformationEditStyle } from './styled'
import {
  Button,
  Section,
  Table,
  Image,
  Modal,
  Switcher,
  Input,
  SelectBox,
  InputTextarea,
  Tag,
  Spinner,
  Breadcrumbs,
  AttachedFile,
} from '../../components'
import { ICONS } from '../../themes'
import {
  ROUTE_PATH,
  STRING,
  findId,
  toastActive,
  toastFail,
  dateMonDayYearTime,
  validateEmail,
} from '../../helpers'
import NumberFormat from 'react-number-format'
import {
  supplierManagementBuyerController,
  comprehensiveAssessmentController,
  comprehensiveController,
} from '../../apiService'
import { Formik, Form, FieldArray, ErrorMessage } from 'formik'
import { connect } from 'react-redux'
import * as yup from 'yup'
import { DebounceInput } from 'react-debounce-input'
import moment from 'moment'
import FileDownload from 'js-file-download'
import { localStorageService } from '../../helpers/functions'

export class SupplierManagementInformationEdit extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      isActive: false,
      isShowTemplate: true,
      modals: [
        { name: 'confirm', isOpen: false },
        { name: 'inviteSupplier', isOpen: false },
        { name: 'inactiveSupplier', isOpen: false },
        { name: 'updateOfflineComprehensiveAssessment', isOpen: false },
      ],
      isValidateReason: false,
      supplierInfo: {},
      statusSupplier: null,
      removeSuppilerActive: false,
      hideContactPerson: false,
      accountStatus: false,
      buttonSaveActive: true,
      oldWarning: '',
      textRelevant: '',
      selectedFile: [],
      is_offline_asssessment: 0,
      formDetail: {
        offlineAssessments: [],
        selectTemplateOption: { value: 0, label: 'Select' },
        templateOption: [],
        offlineLastUpdate: [],
        templateList: [],
      },
      formContact: {
        id: '',
        index: '',
        name: '',
        phone: '',
        email: '',
        is_new_value: false,
      },
      isEditContact: false,
      isValidateFormContactName: false,
      isValidateFormContactEmail: false,
      isValidateFormContactPhone: false,
      // ErrMessageEmail: STRING.INVALID,
      ErrMessageEmail: '',
      ErrMessageName: '',
      isInvite: false,
      file: null,
      resendEmailLoading: false,
      indexResendEmail: null,
      isResendEmail: false,
      validateFormContactErrorText: {
        phone: '',
      },
    }
    this.checkCompanyStatus = this.checkCompanyStatus.bind(this)
    this.renderCompanyType = this.renderCompanyType.bind(this)
    this.renderTaxId = this.renderTaxId.bind(this)
    this.renderBranch = this.renderBranch.bind(this)
    this.renderStatus = this.renderStatus.bind(this)
    this.renderBusinessType = this.renderBusinessType.bind(this)
    this.renderYearEstablished = this.renderYearEstablished.bind(this)
    this.renderRegisteredCapital = this.renderRegisteredCapital.bind(this)
    this.renderServiceCategory = this.renderServiceCategory.bind(this)
    this.renderPhone = this.renderPhone.bind(this)
    this.renderFax = this.renderFax.bind(this)
    this.renderEmail = this.renderEmail.bind(this)
    this.renderWebsite = this.renderWebsite.bind(this)
    this.renderAttachment = this.renderAttachment.bind(this)
    this.renderRelevantTag = this.renderRelevantTag.bind(this)
    this.renderInvitationDate = this.renderInvitationDate.bind(this)
    this.renderRegisteredDate = this.renderRegisteredDate.bind(this)
    this.renderActiveToggle = this.renderActiveToggle.bind(this)
    this.renderUpdateScoreForm = this.renderUpdateScoreForm.bind(this)
  }
  componentDidMount() {
    this._isMounted = true
    this.fetchSuppierByID()

    this.fetchAssessmentsByID()
    this.fetchGetOffline()

    localStorageService.clearSupplierManagement()
  }
  componentWillUnmount() {
    this._isMounted = false
    this.clearState()
  }

  fetchSuppierByID = async () => {
    try {
      const id = findId(window.location.pathname)
      if (!id) {
        this.goBack()
      }
      {
        const res = await supplierManagementBuyerController().getByID(id)
        // console.log(res)
        if (res) {
          if (this._isMounted) {
            this.setState({ oldWarning: res.warning })
          }
          this.initState(res)
        }
      }
    } catch (error) {
      throw ('fetchSuppierByID fail', error)
    }
  }

  fetchGetOffline = async () => {
    try {
      // const params = {
      //   page: this.state.activePage,
      // }
      const res = await comprehensiveController().getOffline()
      // console.log('fetchGetOffline', res)
      if (res) {
        const templateOptionsAfterMap = res.map(i => ({
          ...i,
          value: i.id,
          label: i.name,
        }))

        if (this._isMounted) {
          this.setState({
            formDetail: {
              ...this.state.formDetail,
              templateOption: templateOptionsAfterMap,
              templateList: res,
            },
          })
        }
      }
    } catch (error) {
      throw error
    }
  }

  fetchAssessmentsByID = async () => {
    try {
      const id = findId(window.location.pathname)
      if (!id) return
      const res = await comprehensiveAssessmentController().getOfflineAssessmentID(
        id,
        'asc'
      )

      // console.log('getOfflineAssessmentID', res)

      if (res) {
        const offlineLastUpdateList = res.map(i => ({
          updated: i.updated_at,
          createdBy: i.created_by_name,
        }))

        const offlineAssessments = res.map(r => ({
          ...r,
          max: r.max === 0 && r.min === 0 ? 100 : r.max, // ถ้า min=0 & max=0 ให้เป็น 0-100
        }))

        if (res.length > 0) {
          if (this._isMounted) {
            this.setState({
              formDetail: {
                ...this.state.formDetail,
                offlineAssessments: offlineAssessments,
                offlineLastUpdate: offlineLastUpdateList,
              },
            })
          }
        } else {
          if (this._isMounted) {
            this.setState({
              formDetail: {
                ...this.state.formDetail,
                offlineAssessments: [],
              },
            })
          }
        }
      }
    } catch (error) {
      throw error
    }
  }

  addNewTemplate = async id => {
    try {
      if (!id) return
      const res = await comprehensiveController().getOfflineID(id)
      // console.log({ res })
      if (res) {
        res.topic_offline_template.map(e => {
          delete e.id
        })
        if (this._isMounted) {
          let min = res.min ? res.min : 0
          let max = res.max ? res.max : 100
          if (
            Array.isArray(res.offline_template_grade) &&
            res.offline_template_grade.length > 0
          ) {
            res.offline_template_grade.forEach(otg => {
              if (otg.value_from <= min) min = otg.value_from
              if (otg.value_to >= max) max = otg.value_to
            })
          }
          this.setState(prevState => {
            const newFormDetail = {
              ...prevState.formDetail,
              offlineAssessments: [
                ...prevState.formDetail.offlineAssessments,
                {
                  name: res.name,
                  min: min,
                  max: max,
                  offline_template_grade: res.offline_template_grade,
                  topic_offline_assessment: res.topic_offline_template,
                  total: '',
                  buyer_supplier_company_id: this.state.supplierInfo
                    .my_supplier_id,
                  file_offline_assessment: [],
                  created_at: moment(Date.now()).format('YYYY-MM-DDTHH:mm:ssZ'),
                },
              ],
            }
            return { formDetail: newFormDetail }
          })
        }
      }
    } catch (error) {
      throw error
    }
  }

  _onChangeNation(e) {
    if (this._isMounted) {
      return this.setState({
        supplierNation: e.target.value,
      })
    }
  }

  noCloseAssessment = () => {
    // this.fetchGetOffline()
    // this.fetchAssessmentsByID()
    this.toggleModal('updateOfflineComprehensiveAssessment')
    document.body.classList.remove('modal-open')
  }

  initState = (
    values = {
      id: null,
      tax_id: '',
      company_name: '',
      company_type: '',
      year_established: '',
      regis_capital: null,
      regis_address: '',
      regis_country: '',
      contact_address: '',
      contact_country: '',
      phone: '',
      fax: '',
      email: '',
      website: '',
      attachment: [],
      service_category: [],
      business_type: [],
      contact_person: [],
      financial: '',
      ss: '',
      esg: null,
      warning: '',
      score: '',
      update_date: '',
      supplier_id: null,
      status: '',
      company_id: null,
      status_company: '',
      branch: '',
      operational: '',
      regulatory: '',
      risk_score: '',
      status_supplier: null,
      financial_info: null,
      update_by: '',
    }
  ) => {
    if (this._isMounted) {
      this.setState({
        supplierInfo: values,
        statusSupplier: values.status_account,
      })
    }
    this.setButtonRemoveSuppilerActive(values.status_supplier)
    this.setToggleStatus(values.status_account)
    this.setContactPersonActive()
  }

  clearState = () => {
    if (this._isMounted) {
      return this.setState({
        removeSuppilerActive: false,
        hideContactPerson: false,
        accountStatus: false,
        buttonSaveActive: false,
      })
    }
  }

  setButtonSaveActive = () => {
    if (this._isMounted) {
      return this.setState({ buttonSaveActive: true })
    }
  }

  setToggleStatus = status => {
    const ACTIVE = 1
    if (this._isMounted) {
      return this.setState({
        isActive: status === ACTIVE ? true : false,
      })
    }
  }

  setContactPersonActive = () => {
    const { user } = this.props
    if (user) {
      const { role } = user
      const ROLE_RISK_MANAGEMENT = role === 7
      if (ROLE_RISK_MANAGEMENT) {
        if (this._isMounted) {
          return this.setState({ hideContactPerson: true })
        }
      }
    }
  }

  setButtonRemoveSuppilerActive = statusSupplier => {
    const notRegister = statusSupplier === 0 || statusSupplier === 3
    if (notRegister) {
      if (this._isMounted) {
        return this.setState({ removeSuppilerActive: true })
      }
    }
  }

  statusSuppiler = id => {
    const NOT_REG = 0
    const ACTIVE = 1
    const INACTIVE = 2
    const WAIT_ACTIVE = 3
    switch (id) {
      case '1':
        return ACTIVE
      case '0':
        return NOT_REG
      case '2':
        return INACTIVE
      case '3':
        return WAIT_ACTIVE
      default:
        break
    }
  }

  save = async () => {
    try {
      const {
        supplierInfo,
        statusSupplier,
        buttonSaveActive,
        formDetail,
        selectedFile,
        oldWarning,
      } = this.state
      if (!buttonSaveActive) return
      if (supplierInfo && supplierInfo.my_supplier_id) {
        const dataOfflineAssessmentsMap = formDetail.offlineAssessments
          ? formDetail.offlineAssessments.map((v, i) => {
              return {
                ...v,
                topic_offline_assessment: v.topic_offline_assessment
                  ? v.topic_offline_assessment.map((vto, index) => {
                      return {
                        ...vto,
                        score: vto.score ? parseFloat(vto.score) : '',
                      }
                    })
                  : [],
                total: v.total ? parseFloat(v.total) : '',
              }
            })
          : []
        const params = {
          status:
            this.statusSuppiler(statusSupplier) === undefined
              ? supplierInfo.status_account
              : this.statusSuppiler(statusSupplier),
          my_supplier_id: supplierInfo.my_supplier_id,
          reason:
            supplierInfo.warning === oldWarning ? '' : supplierInfo.warning,
          offline_assessment: JSON.stringify(dataOfflineAssessmentsMap),
          files: selectedFile,
          contact_person: JSON.stringify(supplierInfo.contact_person),
          relevant_news_tag: JSON.stringify(supplierInfo.relevant_news_tag),
          update_date_warning: supplierInfo.update_date_warning,
          is_offline_asssessment: this.state.is_offline_asssessment,
        }
        // console.log('params', params)
        const res = await supplierManagementBuyerController().updateSupplier(
          params
        )
        this.setState({ isLoading: false })
        if (res) {
          if (res.status === 'UpdateSuccess') {
            this.goBack()
            toastActive(res.message)
            document.body.classList.remove('modal-open')
          } else {
            toastFail(res.message)
            document.body.classList.remove('modal-open')
          }
        }
      }
    } catch (error) {
      this.setState({ isLoading: false })
      throw ('update suppiler fail', error)
    }
  }

  removeSuppiler = async () => {
    try {
      const { supplierInfo } = this.state
      if (supplierInfo && supplierInfo.my_supplier_id) {
        const res = await supplierManagementBuyerController().deleteSuppilier(
          supplierInfo.my_supplier_id
        )
        if (res) {
          if (res.status === 'DeleteSuccess' && res.message) {
            this.toggleModal('confirm')
            toastActive(res.message)
            this.goBack()
            document.body.classList.remove('modal-open')
          } else {
            this.toggleModal('confirm')
            toastActive(res.message)
            document.body.classList.remove('modal-open')
          }
        }
      }
    } catch (error) {
      throw ('remove suppiler fail', error)
    }
  }

  goBack = () => {
    this.props.history.push(ROUTE_PATH.SUPPLIER_MANAGEMENT_BUYER.LINK)
    document.body.classList.remove('modal-open')
  }

  toggleModal = (evt, id, name) => {
    if (this._isMounted) {
      return this.setState(prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === evt ? !modal.isOpen : false,
          Idlist: id,
          Fullname: name,
        })),
      }))
    }
  }

  cancelToggleModal = () => {
    this.toggleModal('updateOfflineComprehensiveAssessment')
    document.body.classList.remove('modal-open')
  }

  toggleShowTemplate = id => {
    if (this._isMounted) {
      this.setState(prevState => ({
        isShowTemplate: !prevState.isShowTemplate,
      }))
    }
    return this.addNewTemplate(id)
  }

  handleChange = () => {
    const ACTIVE = '1'
    const INACTIVE = '2'
    const { supplierInfo } = this.state
    if (supplierInfo.warning === '') {
      if (this._isMounted) {
        this.setState({
          isValidateReason: true,
        })
      }
    } else {
      supplierInfo.update_date_warning = moment(Date.now()).format(
        'YYYY-MM-DDTHH:mm:ssZ'
      )
      supplierInfo.update_by_warning = this.props.user.full_name
      if (this._isMounted) {
        this.setState(
          {
            supplierInfo,
            isActive: !this.state.isActive,
            statusSupplier: !this.state.isActive ? ACTIVE : INACTIVE,
          },
          this.toggleModal('inactiveSupplier')
        )
      }
    }
  }

  onClickResendEmail = async (id, email, fullName, phone) => {
    const params = {
      supplier_account_id: id,
      email: email,
      full_name: fullName,
      phone: phone,
    }
    const res = await supplierManagementBuyerController().resendEmailSupplier(
      params
    )
    if (res) {
      if (this._isMounted) {
        this.setState({
          resendEmailLoading: false,
          isResendEmail: false,
        })
      }
      toastActive('Resend Activation Email')
    } else {
      if (this._isMounted) {
        this.setState({
          resendEmailLoading: true,
          isResendEmail: false,
        })
      }
      toastFail('error')
    }
  }

  onSendEmailOnlineTemplate = async () => {
    const { supplierInfo } = this.state
    const res = await supplierManagementBuyerController().sendEmailOnlineTemplate(
      supplierInfo.my_supplier_id
    )
    // console.log(res)
    if (res) {
      if (res === 'Send email request success') {
        toastActive(res)
        this.fetchSuppierByID()
      } else {
        toastFail(res)
      }
    } else {
      toastFail('error')
    }
  }

  onSaveContact = () => {
    this.setState({ isInvite: true })
    let { formContact, supplierInfo } = this.state
    if (this.validateFormContact()) {
      const formContactObjStr = JSON.stringify(formContact)
      const formContactStrParse = JSON.parse(formContactObjStr)
      const isValidateFormContactName = false
      const isValidateFormContactEmail = false
      const isValidateFormContactPhone = false
      let contact = {
        contact_person_id: 0,
        contact_person_full_name: formContactStrParse.name.trim(),
        contact_person_phone: formContactStrParse.phone.trim(),
        contact_person_mail: formContactStrParse.email.trim(),
        is_new_value: true,
        is_edit_value: false,
      }
      const newContactPerson = supplierInfo
      newContactPerson.contact_person.push(contact)
      const formContactClear = {
        id: '',
        index: '',
        name: '',
        phone: '',
        email: '',
      }
      if (this._isMounted) {
        this.setState({
          supplierInfo: newContactPerson,
          isValidateFormContactName,
          isValidateFormContactEmail,
          isValidateFormContactPhone,
          formContact: formContactClear,
        })
      }
      // this.toggleModal('inviteSupplier')
      this.onCloseContact()
      setTimeout(() => {
        this.setState({ isInvite: false })
      }, 500)
    } else {
      this.setState({ isInvite: false })
    }
  }

  onEditContact = index => {
    this.setState({ isInvite: true })
    const { formContact, supplierInfo } = this.state
    if (this.validateFormContact(index)) {
      const isValidateFormContactName = false
      const isValidateFormContactEmail = false
      const isValidateFormContactPhone = false

      supplierInfo.contact_person[index] = {
        ...supplierInfo.contact_person[index],
        contact_person_id: 0,
        contact_person_full_name: formContact.name.trim(),
        contact_person_phone: formContact.phone.trim(),
        contact_person_mail: formContact.email.trim(),
      }
      if (formContact.is_new_value) {
        supplierInfo.contact_person[index].is_new_value = true
        supplierInfo.contact_person[index].is_edit_value = false
      } else {
        supplierInfo.contact_person[index].is_new_value = false
        supplierInfo.contact_person[index].is_edit_value = true
      }

      if (formContact.id !== '') {
        supplierInfo.contact_person[index].contact_person_id = formContact.id
      }
      if (this._isMounted) {
        this.setState({
          supplierInfo,
          isValidateFormContactName,
          isValidateFormContactEmail,
          isValidateFormContactPhone,
        })
      }
      // this.toggleModal('inviteSupplier')
      this.onCloseContact()
      setTimeout(() => {
        this.setState({ isInvite: false })
      }, 500)
    } else {
      this.setState({ isInvite: false })
    }
  }

  onCloseContact = () => {
    const formContact = {
      index: '',
      name: '',
      phone: '',
      email: '',
      is_new_value: false,
    }
    const isValidateFormContactName = false
    const isValidateFormContactEmail = false
    const isValidateFormContactPhone = false
    const ErrMessageName = ''
    const ErrMessageEmail = ''
    if (this._isMounted) {
      this.setState(
        {
          ErrMessageEmail,
          ErrMessageName,
          isValidateFormContactName,
          isValidateFormContactEmail,
          isValidateFormContactPhone,
          formContact,
        },
        this.toggleModal('inviteSupplier')
      )
    }
  }

  onClickEditContact = (i, e) => {
    const formContact = {
      index: i,
      id: e.contact_person_id,
      name: e.contact_person_full_name,
      email: e.contact_person_mail,
      phone: e.contact_person_phone,
      is_new_value: e.is_new_value,
    }
    const isEditContact = true
    if (this._isMounted) {
      this.setState(
        { isEditContact, formContact },
        this.toggleModal('inviteSupplier')
      )
    }
  }

  onClickCancalInvitel = index => {
    const { supplierInfo } = this.state
    const formContact = {
      id: '',
      index: '',
      name: '',
      phone: '',
      email: '',
    }
    if (index > -1) {
      if (supplierInfo.contact_person[index].contact_person_id === 0) {
        supplierInfo.contact_person.splice(index, 1)
      } else {
        supplierInfo.contact_person[index].contact_person_activate = 4
      }
    }
    if (this._isMounted) {
      this.setState(
        {
          supplierInfo,
          formContact,
        },
        this.toggleModal('inviteSupplier')
      )
    }
  }

  validateFormContact = index => {
    let { formContact, ErrMessageName, ErrMessageEmail } = this.state
    let isValidateFormContactName = false
    let isValidateFormContactEmail = false
    let isValidateFormContactPhone = false

    let isPass = true
    if (formContact.name.trim() === '') {
      isPass = false
      isValidateFormContactName = true
      ErrMessageName = STRING.INVALID
    } else {
      ErrMessageName = ''
    }
    if (formContact.email.trim() === '') {
      isPass = false
      isValidateFormContactEmail = true
      ErrMessageEmail = STRING.INVALID
    } else if (!validateEmail(formContact.email.trim())) {
      isPass = false
      isValidateFormContactEmail = true
      ErrMessageEmail = 'Email format invalid'
    } else if (this.checkEmailDuplicate(formContact.email, index)) {
      isPass = false
      isValidateFormContactEmail = true
      ErrMessageEmail = 'Email duplicate'
    } else {
      ErrMessageEmail = ''
    }

    const checkLengthPhone = formContact.phone && formContact.phone.length == 10
    if (formContact.phone.trim() === '') {
      isPass = false
      isValidateFormContactPhone = true
      const requireFieldPhoneStr = JSON.stringify(
        this.state.validateFormContactErrorText
      )
      const requireFieldPhoneParse = JSON.parse(requireFieldPhoneStr)
      requireFieldPhoneParse.phone = 'This field is required'
      if (this._isMounted) {
        this.setState({
          validateFormContactErrorText: { ...requireFieldPhoneParse },
        })
      }
    }
    // else if (checkLengthPhone == false) {
    //   isPass = false
    //   isValidateFormContactPhone = true
    //   const phoneNumberInvalidStr = JSON.stringify(
    //     this.state.validateFormContactErrorText
    //   )
    //   const phoneNumberInvalidParse = JSON.parse(phoneNumberInvalidStr)
    //   phoneNumberInvalidParse.phone = 'The phone number is invalid'
    //   this.setState({
    //     validateFormContactErrorText: { ...phoneNumberInvalidParse },
    //   })
    // }
    if (this._isMounted) {
      this.setState({
        ErrMessageEmail,
        ErrMessageName,
        isValidateFormContactName,
        isValidateFormContactEmail,
        isValidateFormContactPhone,
      })
    }
    return isPass
  }

  checkEmailDuplicate = (values, index) => {
    const { supplierInfo } = this.state
    if (values) {
      const emailList = supplierInfo.contact_person || []
      const email = values
      if (email) {
        const duplicateTopicName = emailList.find((e, i) => {
          if (index !== i) {
            return email.toLowerCase() === e.contact_person_mail.toLowerCase()
          }
        })
        return duplicateTopicName
      }
    }
  }

  disableInviteSupplier() {
    const { supplierInfo } = this.state
    let isHide = false
    if (
      !!supplierInfo.contact_person &&
      supplierInfo.contact_person.length > 0
    ) {
      supplierInfo.contact_person.map(e => {
        if (e.contact_person_activate !== 4) {
          isHide = true
          return
        }
      })
      return isHide
    }
  }

  onClickActive = () => {
    const { supplierInfo } = this.state
    if (!this.state.isActive) {
      const ACTIVE = '1'
      const INACTIVE = '2'
      if (this._isMounted) {
        this.setState({
          isActive: !this.state.isActive,
          statusSupplier: !this.state.isActive ? ACTIVE : INACTIVE,
        })
      }
    } else {
      supplierInfo.warning = ''
      if (this._isMounted) {
        this.setState(
          {
            supplierInfo,
          },
          this.toggleModal('inactiveSupplier')
        )
      }
    }
  }

  // enter mode
  // _relevantTagAdd(e) {
  //   const { supplierInfo } = this.state
  //   const value = e.target.value
  //   const trimValue = value.trim()
  //   const findSameTag = supplierInfo.relevant_news_tag.findIndex(
  //     i => i.name.toLowerCase() === trimValue.toLowerCase()
  //   )
  //   const notSameTag = findSameTag === -1
  //   if (e.keyCode == 13 && value.length >= 3 && trimValue !== '') {
  //     // Check same Tag
  //     if (notSameTag) {
  //       const Tag = {
  //         name: trimValue,
  //         supplier_company_id: supplierInfo.my_supplier_id,
  //       }
  //       supplierInfo.relevant_news_tag.push(Tag)
  //       this.setState({ supplierInfo, textRelevant: '' })
  //     }
  //   }
  // }

  onClickTagAdd(e) {
    const { supplierInfo } = this.state
    const trimValue = e.trim()
    const findSameTag = supplierInfo.relevant_news_tag.findIndex(
      i => i.name.toLowerCase() === trimValue.toLowerCase()
    )
    const notSameTag = findSameTag === -1
    if (notSameTag && trimValue !== '') {
      const Tag = {
        name: trimValue,
        supplier_company_id: supplierInfo.my_supplier_id,
      }
      supplierInfo.relevant_news_tag.push(Tag)
      if (this._isMounted) {
        this.setState({ supplierInfo, textRelevant: '' })
      }
    }
  }

  _relevantTagRemove(index) {
    const { supplierInfo } = this.state
    supplierInfo.relevant_news_tag.splice(index, 1)
    if (this._isMounted) {
      return this.setState({ supplierInfo })
    }
  }

  onChangeReason = e => {
    let { supplierInfo } = this.state
    supplierInfo.warning = e.target.value
    if (this._isMounted) {
      this.setState({
        isValidateReason: false,
        supplierInfo,
      })
    }
  }

  setInputArrayName = (formikSetvalue, event, index) => {
    const { target } = event
    formikSetvalue(`offlineAssessments[${index}].name`, target.value)
  }

  setInputArrayScore = (formikSetvalue, event, index, indexTopicOffline) => {
    const { target } = event
    let val = target.value + ''
    if (val) {
      const num = val.match(/[0-9.]+/gi)
      if (num) {
        val = num[0]
      }
    }

    formikSetvalue(
      `offlineAssessments[${index}].topic_offline_assessment[${indexTopicOffline}].score`,
      val
    )
  }

  setInputArrayNote = (formikSetvalue, event, index, indexTopicOffline) => {
    const { target } = event
    formikSetvalue(
      `offlineAssessments[${index}].topic_offline_assessment[${indexTopicOffline}].note`,
      target.value
    )
  }

  setInputArrayTotal = (formikSetvalue, event, index) => {
    const { target } = event
    formikSetvalue(`offlineAssessments[${index}].total`, target.value)
  }

  showErrOfflineAssessmentsScore = (
    formikError,
    indexArrOfflineAssessments,
    indexTopicOffline,
    id,
    subItem
  ) => {
    if (formikError) {
      if (formikError.offlineAssessments) {
        const { offlineAssessments } = formikError
        const err = offlineAssessments[indexArrOfflineAssessments]
        if (err) {
          if (err.topic_offline_assessment && id) {
            const subErr = err.topic_offline_assessment[indexTopicOffline]
            if (subErr) return 'is-error'
          }
        }
      }
    }
  }

  errorScore = (
    formikError,
    indexArrOfflineAssessments,
    indexTopicOffline,
    id
  ) => {
    if (formikError) {
      if (formikError.offlineAssessments) {
        const { offlineAssessments } = formikError
        const err = offlineAssessments[indexArrOfflineAssessments]
        if (err) {
          if (err.topic_offline_assessment && id) {
            const subErr = err.topic_offline_assessment[indexTopicOffline]
            if (subErr) return subErr.score
          }
        }
      }
    }
  }

  showErrOfflineAssessmentsTotal = (
    formikError,
    indexArrOfflineAssessments
  ) => {
    if (this.state.is_offline_asssessment === 1) {
      if (formikError) {
        if (formikError.offlineAssessments) {
          const { offlineAssessments } = formikError
          const err = offlineAssessments[indexArrOfflineAssessments]
          if (err) {
            if (err.total) {
              return 'is-error'
            }
          }
        }
      }
    }
  }

  errorTotalScore = (formikError, indexArrOfflineAssessments) => {
    if (formikError) {
      if (formikError.offlineAssessments) {
        const { offlineAssessments } = formikError
        const err = offlineAssessments[indexArrOfflineAssessments]
        if (err) {
          if (err.total) {
            return err.total
          }
        }
      }
    }
  }

  setInputArrayUploadFile = (file, data, index, formikSetvalue) => {
    const { formDetail } = this.state
    // if (file.length) {
    // if (this._isMounted) {
    // console.log('random', Math.random().toString(36).substring(2, 8))
    this.setState({
      selectedFile: [
        ...this.state.selectedFile,
        {
          name: file.name,
          files: file,
          // is_deleted: false,
        },
      ],
    })
    let dataFiles = Array.isArray(data.file_offline_assessment)
      ? [...data.file_offline_assessment]
      : []
    // console.log('dataFile', dataFiles)
    dataFiles.push({
      fake_id: Math.random().toString(36).substring(2, 8),
      name: file.name,
      files: file,
      is_deleted: false,
    })
    data = { ...data, file_offline_assessment: dataFiles }
    // console.log('Data Final', data)

    // formDetail.offlineAssessments[index] = data
    formikSetvalue(
      `offlineAssessments[${index}].file_offline_assessment`,
      dataFiles
    )
    this.setState({ formDetail: formDetail })
    // }
    // } else {
    // this.file = null
    // }
  }

  downloadAttachmentOffline = data => {
    // console.log('data dowload', data)
    // return supplierManagementBuyerController()
    //   .downloadAttachment(params.id)
    //   .then(res => FileDownload(res.data, params.name))
    if (data.id) {
      return comprehensiveAssessmentController()
        .downloadAssessments(data.id)
        .then(res => {
          console.log({ res })
          if (res) {
            FileDownload(res.data, data.name)
          }
        })
    } else {
      FileDownload(data.files, data.name)
    }
  }

  updateOfflineTemplates = async value => {
    const { formDetail } = this.state
    // console.log({ value })
    let validTotalScore = false
    for (var i = 0; i < value.length; i++) {
      for (var l = 0; l < formDetail.templateList.length; l++) {
        if (formDetail.templateList[l].name === value[i].name) {
          let { min, max } = value[i]
          let { total } = value[i]
          min = +min
          max = +max
          total = +total
          // console.log({ min, max, total })
          if (min < max) {
            validTotalScore = total < min || total > max
          }
        }
      }
    }

    if (validTotalScore) {
      toastFail('Please check total score')
    } else {
      formDetail.offlineAssessments = value
      if (this._isMounted) {
        return this.setState(
          {
            formDetail,
          },
          this.toggleModal('updateOfflineComprehensiveAssessment')
        )
      }
    }
  }

  onClickAddTemplete = (value, valueofflineAssessments) => {
    const { formDetail } = this.state
    // console.log({ value, valueofflineAssessments })
    if (!value) {
      toastFail('Please add template name')
    } else {
      this.toggleShowTemplate(value.value)
      formDetail.offlineAssessments = valueofflineAssessments
      if (this._isMounted) {
        this.setState({
          formDetail,
        })
      }
    }
  }

  onSelectTemplateOption = (value = {}, formilActions = () => {}) => {
    if (value && formilActions) {
      formilActions.setFieldValue('selectTemplateOption', value)
    }
  }

  removeTemplate = index => {
    if (!index) return
    if (this._isMounted) {
      this.setState(prevState => {
        const { offlineAssessments } = prevState.formDetail
        const remove = offlineAssessments.splice(index, 1)
        return {
          ...prevState,
          formDetail: {
            ...prevState.formDetail,
            offlineAssessments: remove,
          },
        }
      })
    }
  }

  onClickInviteSupplier = () => {
    if (this._isMounted) {
      return this.setState(
        {
          isEditContact: false,
        },
        this.toggleModal('inviteSupplier')
      )
    }
  }

  checkPositiveInt = () => {
    return `^[0-9]+(\.[0-9]{1,2})?$`
  }

  validateSchema = () => {
    const schema = yup.object({
      offlineAssessments: yup.array().of(
        yup.object().shape({
          total: yup
            .string()
            .matches(this.checkPositiveInt(), STRING.DECIMAL)
            .required(STRING.INVALID),
          topic_offline_assessment: yup.array().of(
            yup.object().shape({
              score: yup
                .string()
                .matches(this.checkPositiveInt(), STRING.DECIMAL),
            })
          ),
        })
      ),
    })
    return schema
  }

  downloadAttachment = params => {
    return supplierManagementBuyerController()
      .downloadAttachment(params.id)
      .then(res => FileDownload(res.data, params.name))
  }

  renderContactPersonList = () => {
    const { supplierInfo, resendEmailLoading, isResendEmail } = this.state
    if (
      supplierInfo &&
      supplierInfo.contact_person &&
      supplierInfo.contact_person.length
    ) {
      const listContactperson = supplierInfo.contact_person.map((cp, index) => {
        const showButtonEdit = cp.contact_person_activate !== 1
        const cancelInvite = cp.contact_person_activate === 4
        if (!cancelInvite) {
          return (
            <Table.TR key={index}>
              <Table.TD className="full-name">
                {cp.contact_person_full_name}
              </Table.TD>
              <Table.TD className="phone">
                <span>Phone: </span>
                {cp.contact_person_phone}
              </Table.TD>
              <Table.TD className="email">
                <span>Email: </span>
                {cp.contact_person_mail}
              </Table.TD>
              {showButtonEdit && cp.can_edit && (
                <Table.TD className="resend-activation-email">
                  <Button
                    className="theme-blue btn-width-auto"
                    onClick={() => {
                      this.onClickEditContact(index, cp)
                    }}
                  >
                    Edit
                  </Button>
                </Table.TD>
              )}
              {cp.is_new_value ||
                (showButtonEdit && (
                  <Table.TD className="resend-activation-email">
                    <Button
                      className="theme-blue btn-width-auto"
                      disabled={isResendEmail || cp.is_edit_value}
                      onClick={() => {
                        if (!cp.is_edit_value) {
                          this.onClickResendEmail(
                            cp.contact_person_id,
                            cp.contact_person_mail,
                            cp.contact_person_full_name,
                            cp.contact_person_phone
                          )
                          if (this._isMounted) {
                            return this.setState({
                              resendEmailLoading: true,
                              indexResendEmail: index,
                              isResendEmail: true,
                            })
                          }
                        }
                      }}
                    >
                      {this.state.indexResendEmail == index &&
                      resendEmailLoading ? (
                        <span className="loader"></span>
                      ) : (
                        'Resend Email'
                      )}
                    </Button>
                  </Table.TD>
                ))}
            </Table.TR>
          )
        }
      })

      return listContactperson
    }
  }

  checkCompanyStatus(supplierInfo) {
    if (supplierInfo.status_supplier === 0) {
      return <div className="not-regis-status">Not Registered</div>
    } else if (supplierInfo.status_supplier === 1) {
      return <div className="active-status">Registered</div>
    } else if (supplierInfo.status_supplier === 2) {
      return <div className="registration-status">inActive</div>
    } else if (supplierInfo.status_supplier === 3) {
      return <div className="wait-active-status">Waiting for registration</div>
    }
  }

  renderCompanyType(supplierInfo) {
    if (!supplierInfo.company_type) {
      return <div className="data">N/A</div>
    } else return <div className="data">{supplierInfo.company_type} </div>
  }

  renderTaxId(supplierInfo) {
    if (supplierInfo.tax_id == '') {
      return <div className="data">N/A</div>
    } else return <div className="data">{supplierInfo.tax_id}</div>
  }

  renderBranch(supplierInfo) {
    if (supplierInfo.branch == '') {
      return <div className="data">N/A</div>
    } else return <div className="data">{supplierInfo.branch}</div>
  }

  renderStatus(supplierInfo, statusCompany) {
    if (
      supplierInfo.status_company == '' ||
      supplierInfo.status_company == '0'
    ) {
      return <div className="data">N/A</div>
    } else return <div className="data">{`${statusCompany}`}</div>
  }

  renderBusinessType(supplierInfo) {
    if (supplierInfo.business_type && supplierInfo.business_type.length > 0) {
      return (
        <div className="data">
          {supplierInfo.business_type.map((businessType, i) =>
            supplierInfo.business_type.length === i + 1
              ? businessType.business_type_name
              : businessType.business_type_name + ', '
          )}
        </div>
      )
    } else return <div className="data">N/A</div>
  }

  renderYearEstablished(supplierInfo) {
    if (
      supplierInfo.year_established &&
      supplierInfo.company_type != 'Individual'
    ) {
      return <div className="data">{supplierInfo.year_established}</div>
    } else return <div className="data">N/A</div>
  }

  renderRegisteredCapital(supplierInfo) {
    if (
      supplierInfo.regis_capital > -1 &&
      supplierInfo.company_type != 'Individual'
    ) {
      return (
        <>
          <NumberFormat
            value={supplierInfo.regis_capital}
            displayType={'text'}
            thousandSeparator={true}
          />
          &nbsp;
          {supplierInfo.currency.name}
        </>
      )
    } else return 'N/A'
  }

  renderServiceCategory(supplierInfo) {
    if (
      supplierInfo.service_category &&
      supplierInfo.service_category.length > 0
    ) {
      return (supplierInfo.service_category || []).map(item => (
        <div key={item.sub_category_id}>
          {item.category_name}&nbsp;
          {item.sub_category_name !== '' ? '>' : null}
          &nbsp;
          {item.sub_category_name}
        </div>
      ))
    } else return 'N/A'
  }

  renderPhone(supplierInfo) {
    if (supplierInfo.phone && supplierInfo.phone !== '') {
      return supplierInfo.phone
    } else return 'N/A'
  }

  renderFax(supplierInfo) {
    if (supplierInfo.fax && supplierInfo.fax !== '') {
      return supplierInfo.fax
    } else return 'N/A'
  }

  renderEmail(supplierInfo) {
    if (supplierInfo.email && supplierInfo.email !== '') {
      return supplierInfo.email
    } else return 'N/A'
  }

  renderWebsite(supplierInfo) {
    if (supplierInfo.website && supplierInfo.website !== '') {
      return (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={'http://' + supplierInfo.website}
        >
          {supplierInfo.website.replace(/^https?\:\/\//i, '')}
        </a>
      )
    } else return 'N/A'
  }

  renderAttachment(supplierInfo) {
    if (supplierInfo.attachment && supplierInfo.attachment.length > 0) {
      return supplierInfo.attachment.map((e, i) => {
        return (
          <React.Fragment key={i}>
            <Section className="attached-file-list">
              <a
                key={i}
                href={null}
                onClick={() => {
                  this.downloadAttachment(e)
                }}
                target="_blank"
                className="file-link"
                rel="noopener noreferrer"
              >
                <span className="file-name">{e.name}</span>
              </a>
            </Section>
          </React.Fragment>
        )
      })
    } else return 'N/A'
  }

  renderRelevantTag(supplierInfo) {
    return (
      !!supplierInfo.relevant_news_tag &&
      supplierInfo.relevant_news_tag.map((item, i) => (
        <Tag
          key={i}
          onClickRemove={() => this._relevantTagRemove(i)}
          text={item.name}
        />
      ))
    )
  }

  renderInvitationDate(supplierInfo) {
    if (
      supplierInfo.contact_person &&
      supplierInfo.contact_person.length > 0 &&
      supplierInfo.invited_date &&
      supplierInfo.invited_date !== '0001-01-01T00:00:00Z'
    ) {
      return dateMonDayYearTime(supplierInfo.invited_date)
    } else return '-'
  }

  renderRegisteredDate(supplierInfo) {
    if (
      supplierInfo.registered_date &&
      supplierInfo.status_supplier !== 0 &&
      supplierInfo.registered_date !== '0001-01-01T00:00:00Z' &&
      supplierInfo.status_supplier === 1
    ) {
      return dateMonDayYearTime(supplierInfo.registered_date)
    } else return '-'
  }

  renderActiveToggle(supplierInfo) {
    if (!this.state.isActive) {
      return (
        <Section className="data red-text">
          <div>
            Inactive on {dateMonDayYearTime(supplierInfo.update_date_warning)}{' '}
            by {supplierInfo.update_by_warning}
          </div>
          <div>{supplierInfo.warning}</div>
        </Section>
      )
    }
  }

  renderValidateScore(offlineAssessments, topic_offline_assessment) {
    const { min, max } = offlineAssessments
    const { score } = topic_offline_assessment
    // console.log({ offlineAssessments, score, max })
    if (score === null || score === undefined || score === '') {
      // console.log(null)
      return null
    } else if (
      max !== 0 &&
      (parseFloat(score) < min || parseFloat(score) > max)
    ) {
      return `Please insert ${min} - ${max} `
    } else if (parseInt(score) < 0 || parseInt(score) > 100) {
      return `Please insert 0 - 100`
    }
    return null
  }

  renderUpdateScoreForm(modals, supplierInfo) {
    return (
      <Modal
        className="update-offline-comprehensive-assessment theme-blue"
        isOpen={
          modals
            .filter(modal => {
              return modal.name === 'updateOfflineComprehensiveAssessment'
            })
            .map(obj => obj.isOpen)[0]
        }
      >
        <Formik
          enableReinitialize
          initialValues={this.state.formDetail}
          validateOnChange={true}
          validateOnBlur={false}
          validationSchema={this.validateSchema}
          onSubmit={values => {
            this.updateOfflineTemplates(values.offlineAssessments)
          }}
        >
          {formikProps => {
            const {
              values,
              errors,
              submitForm,
              setFieldValue,
              setErrors,
              resetForm,
            } = formikProps
            return (
              <Form onSubmit={submitForm}>
                <Modal.Header>
                  Update Offline Comprehensive Assessment
                </Modal.Header>
                <Modal.Body>
                  {values.offlineLastUpdate.length > 0 ? (
                    <Section className="last-update">
                      Last Update:&nbsp;
                      {dateMonDayYearTime(supplierInfo.update_date)}
                      &nbsp;by&nbsp;
                      {supplierInfo.update_by}
                    </Section>
                  ) : (
                    ''
                  )}
                  <React.Fragment>
                    <Section className="form-wrapper">
                      <Section className="form-group select-template">
                        <label>Select Evaluate Template:</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <SelectBox
                              className="select-template"
                              name="selectTemplateOption"
                              value={values.selectTemplateOption}
                              options={values.templateOption}
                              isSearchable={false}
                              //isClearable={true}
                              // placeholder="test"
                              onChange={value => {
                                console.log({ value })
                                this.onSelectTemplateOption(value, formikProps)
                              }}
                            />

                            <Button
                              className="theme-blue"
                              onClick={() => {
                                this.onClickAddTemplete(
                                  values.selectTemplateOption,
                                  values.offlineAssessments
                                )
                              }}
                              style={{ minWidth: '36%' }}
                            >
                              Add
                            </Button>
                          </Section>
                        </Section>
                      </Section>
                    </Section>

                    {/* template group */}
                    <FieldArray
                      name="offlineAssessments"
                      render={() => {
                        return (
                          <Section className="form-wrapper">
                            {values.offlineAssessments.map((item, index) => {
                              const handlersDeleteFile = e => {
                                const { file_offline_assessment } = item
                                if (file_offline_assessment.length > 0) {
                                  file_offline_assessment.map(file => {
                                    if (file.id && file.id === e.id) {
                                      file.is_deleted = true
                                    } else if (
                                      file.fake_id &&
                                      file.fake_id === e.fake_id
                                    ) {
                                      file.is_deleted = true
                                    }
                                  })
                                  this.forceUpdate()
                                }
                              }
                              return (
                                <Section
                                  key={item.id}
                                  className="template-form-group"
                                >
                                  <Section className="input-content">
                                    <Section className="form-group template-name">
                                      <Section className="form-group-control">
                                        <Section className="form-group-inner-wrapper">
                                          <Input
                                            type="text"
                                            name="templateName"
                                            value={item.name}
                                            disabled
                                            onChange={event => {
                                              this.setInputArrayName(
                                                setFieldValue,
                                                event,
                                                index
                                              )
                                            }}
                                            defaultValue="name"
                                            style={{ width: 'unset' }}
                                          />
                                          <Button
                                            className="link"
                                            onClick={() => {
                                              values.offlineAssessments.splice(
                                                index,
                                                1
                                              ),
                                                this.forceUpdate()
                                            }}
                                          >
                                            Remove
                                          </Button>
                                        </Section>
                                      </Section>
                                    </Section>
                                    {values.offlineAssessments.length > 0 ? (
                                      <Section className="add-date">
                                        (Add Date:{' '}
                                        {dateMonDayYearTime(item.created_at)})
                                      </Section>
                                    ) : (
                                      ''
                                    )}
                                    {(item.topic_offline_assessment || []).map(
                                      (subItem, indexTopicOffline) => (
                                        <Section
                                          key={subItem && subItem.id}
                                          className="offline-comprehensive-assessment-block"
                                        >
                                          <Section className="block-order">
                                            {indexTopicOffline + 1}
                                          </Section>

                                          <Section className="block-detail">
                                            <div className="title">
                                              {subItem && subItem.name}
                                            </div>

                                            <Section
                                              className={`form-group ${this.showErrOfflineAssessmentsScore(
                                                errors,
                                                index,
                                                indexTopicOffline,
                                                subItem.id,
                                                subItem
                                              )}`}
                                            >
                                              <label>Score:</label>

                                              <Section className="form-group-control">
                                                <Section className="form-group-inner-wrapper">
                                                  <Input
                                                    type="text"
                                                    inputmode="number"
                                                    name="score"
                                                    placeholder="0"
                                                    defaultValue=""
                                                    value={
                                                      subItem.score
                                                        ? subItem.score
                                                        : null
                                                    }
                                                    onKeyPress={e => {
                                                      if (
                                                        !/[0-9.]/.test(e.key)
                                                      ) {
                                                        e.preventDefault()
                                                        return false
                                                      }

                                                      return true
                                                    }}
                                                    onChange={event => {
                                                      // console.log({ event })
                                                      subItem.score =
                                                        event.target.value
                                                      this.setInputArrayScore(
                                                        setFieldValue,
                                                        event,
                                                        index,
                                                        indexTopicOffline
                                                      )
                                                    }}
                                                  />
                                                </Section>
                                              </Section>
                                            </Section>

                                            <Section className="form-group">
                                              <label>Note:</label>

                                              <Section className="form-group-control">
                                                <Section className="form-group-inner-wrapper">
                                                  <InputTextarea
                                                    type="text"
                                                    name="note"
                                                    onChange={event => {
                                                      this.setInputArrayNote(
                                                        setFieldValue,
                                                        event,
                                                        index,
                                                        indexTopicOffline
                                                      )
                                                    }}
                                                    value={
                                                      subItem && subItem.note
                                                    }
                                                  />
                                                </Section>
                                              </Section>
                                            </Section>
                                          </Section>
                                        </Section>
                                      )
                                    )}
                                    <Section className="total-score-block">
                                      <Section
                                        className={`form-group ${this.showErrOfflineAssessmentsTotal(
                                          errors,
                                          index
                                        )}`}
                                      >
                                        <label className="required">
                                          Total Score:
                                        </label>

                                        <Section className="form-group-control">
                                          <Section className="form-group-inner-wrapper">
                                            <Input
                                              type="text"
                                              name="total"
                                              value={item.total}
                                              onKeyPress={e => {
                                                if (!/[0-9.]/.test(e.key)) {
                                                  e.preventDefault()
                                                  return false
                                                }

                                                return true
                                              }}
                                              onChange={event => {
                                                this.setInputArrayTotal(
                                                  setFieldValue,
                                                  event,
                                                  index
                                                )
                                              }}
                                            />
                                          </Section>

                                          <Section className="message">
                                            <ErrorMessage
                                              name={`offlineAssessments.${index}.total`}
                                            />
                                            {(() => {
                                              let {
                                                min = 0,
                                                max = 0,
                                                total = 0,
                                              } = item
                                              min = +min
                                              max = +max
                                              total = +total
                                              if (item.total !== 0) {
                                                if (
                                                  total < min ||
                                                  total > max
                                                ) {
                                                  return `Please insert ${item.min} - ${item.max}`
                                                } else if (
                                                  total < 0 ||
                                                  total > 100
                                                ) {
                                                  return `Please insert 0 - 100`
                                                }
                                              }
                                            })()}
                                          </Section>
                                        </Section>
                                      </Section>
                                    </Section>
                                  </Section>

                                  <Section className="input-attach">
                                    <AttachedFile
                                      index={index}
                                      id={'upload' + index}
                                      name={'upload' + index}
                                      onSelect={(file, e, cb) => {
                                        if (file) {
                                          this.setInputArrayUploadFile(
                                            file,
                                            item,
                                            index,
                                            setFieldValue
                                          )
                                          cb()
                                        }
                                      }}
                                      fileList={
                                        item.file_offline_assessment || []
                                      }
                                      hasRemove={true}
                                      onDownload={e =>
                                        this.downloadAttachmentOffline(e)
                                      }
                                      onClickRemove={e => handlersDeleteFile(e)}
                                    />
                                  </Section>
                                </Section>
                              )
                            })}
                          </Section>
                        )
                      }}
                    />
                  </React.Fragment>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    className="theme-border-gray close"
                    onClick={() => {
                      this.noCloseAssessment(), setErrors({}), resetForm()
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    className="theme-green save"
                    onClick={() => {
                      submitForm(), document.body.classList.remove('modal-open')
                      if (this._isMounted) {
                        return this.setState({ is_offline_asssessment: 1 })
                      }
                    }}
                  >
                    Ok
                  </Button>
                </Modal.Footer>
              </Form>
            )
          }}
        </Formik>
      </Modal>
    )
  }

  render() {
    const {
      isModalWarningIsOpen,
      isActive,
      modals,
      hideContactPerson,
      removeSuppilerActive,
      supplierInfo,
      formContact,
      isEditContact,
      isValidateFormContactName,
      isValidateFormContactEmail,
      isValidateFormContactPhone,
      isLoading,
      ErrMessageEmail,
      ErrMessageName,
      resendEmailLoading,
    } = this.state
    let statusCompany = ''
    switch (supplierInfo.status_company) {
      case '1':
        statusCompany = 'ยังดำเนินกิจการอยู่'
        break
      case '2':
        statusCompany = 'พิทักษ์ทรัพย์เด็ดขาด'
        break
      case '3':
        statusCompany = 'แปรสภาพ'
        break
      case '4':
        statusCompany = 'เลิก'
        break
      case '5':
        statusCompany = 'เสร็จการชำระบัญชี'
        break
      case '6':
        statusCompany = 'ควบ'
        break
      case '7':
        statusCompany = 'ถอนหนังสือบริคณห์สนธิ'
        break
      case '8':
        statusCompany = 'ร้าง'
        break
      case '9':
        statusCompany = 'ล้มละลาย'
        break
      case 'A':
        statusCompany = 'ฟื้นฟู'
        break
      case 'B':
        statusCompany = 'คืนสู่ทะเบียน'
        break
      case 'D':
        statusCompany = 'สิ้นสภาพ'
        break
      default:
    }
    const isDisableInviteSupplier = this.disableInviteSupplier()
    // console.log('supplierInfo', supplierInfo)
    return (
      <React.Fragment>
        {isLoading && <Spinner className="loading" />}
        <React.Fragment>
          <SupplierManagementInformationEditStyle>
            {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
            <Section className="page-topbar">
              <Section className="page-header">
                <Section className="page-icon">
                  <Image
                    id="page_icon_buyer_management"
                    src={ICONS['icon-user-group-white.svg']}
                    alt="page icon"
                  />
                </Section>

                <Section className="title-and-breadcrumb">
                  <Section id="page_title_buyer_management" className="title">
                    {STRING.SUPPLIER_MANAGEMENT}
                  </Section>
                  <Breadcrumbs props={this.props} />
                </Section>
              </Section>
            </Section>

            {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
            <Section className="main-content">
              <Section className="content-body">
                <Section className="detail-wrapper">
                  <Section className="detail-group-title">
                    {STRING.EDIT_SUPPLIER}
                  </Section>

                  <Section className="supplier-management-information edit">
                    <Section className="info-wrapper">
                      <Section className="detail-group">
                        <div className="label">{STRING.COMPANY_NAME}:</div>

                        <div className="data-control">
                          <div className="data">
                            {supplierInfo.company_name}
                          </div>
                          {this.checkCompanyStatus(supplierInfo)}
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">Country:</div>

                        <div className="data-control">
                          <div className="data">
                            {supplierInfo.contact_country &&
                            supplierInfo.contact_country.name
                              ? supplierInfo.contact_country.name
                              : 'N/A'}
                          </div>
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">Company Type:</div>
                        {this.renderCompanyType(supplierInfo)}
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.TAX_ID}:</div>

                        <div className="data-control">
                          {this.renderTaxId(supplierInfo)}
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.BRANCH}:</div>
                        {this.renderBranch(supplierInfo)}
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.STATUS}:</div>

                        <div className="data-control">
                          {this.renderStatus(supplierInfo, statusCompany)}
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.REGIS_ADDRESS}:</div>

                        <div className="data-control">
                          <div className="data">{`${
                            supplierInfo.regis_address &&
                            supplierInfo.regis_address !== ''
                              ? supplierInfo.regis_address
                              : 'N/A'
                          }`}</div>
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.CONTACT_ADDRESS}:</div>

                        <div className="data-control">
                          <div className="data">{`${supplierInfo.contact_address}`}</div>
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.BUSINESS_TYPE}:</div>
                        <div className="data-control">
                          {this.renderBusinessType(supplierInfo)}
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.YEAR_ESTABLISHED}:</div>

                        <div className="data-control">
                          {this.renderYearEstablished(supplierInfo)}
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">
                          {STRING.REGISTERED_CAPITAL}:
                        </div>

                        <div className="data-control">
                          <div className="data">
                            {this.renderRegisteredCapital(supplierInfo)}
                          </div>
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.SERVICE_CATEGORY}:</div>

                        <div className="data-control">
                          <div className="data">
                            <span>
                              {this.renderServiceCategory(supplierInfo)}
                            </span>
                          </div>
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.PHONE}:</div>

                        <div className="data-control">
                          <div className="data">
                            {this.renderPhone(supplierInfo)}
                          </div>
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.FAX}:</div>

                        <div className="data-control">
                          <div className="data">
                            {this.renderFax(supplierInfo)}
                          </div>
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.EMAIL_LABEL}:</div>

                        <div className="data-control">
                          <div className="data">
                            {this.renderEmail(supplierInfo)}
                          </div>
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.WEBSITE}:</div>

                        <div className="data-control">
                          <div className="data">
                            {this.renderWebsite(supplierInfo)}
                          </div>
                        </div>
                      </Section>

                      {/* --------------------------
                      Attachment: down
                      ----------------------------*/}
                      <Section className="detail-group attachment">
                        <div className="label">{STRING.ATTACHMENT}:</div>

                        <div className="form-group-control">
                          <div className="data">
                            {this.renderAttachment(supplierInfo)}
                          </div>
                        </div>
                      </Section>

                      <Section className="detail-group company-ref">
                        <div className="label">{STRING.COMPANY_REF}:</div>
                        <div className="data-control">
                          <div className="data">
                            {supplierInfo.reference_no
                              ? supplierInfo.reference_no
                              : 'N/A'}
                          </div>
                        </div>
                      </Section>

                      {/* --------------------------
                      Contact Person:
                      ----------------------------*/}

                      <Section className="detail-group contact-person">
                        <div className="label">{STRING.CONTACT_PERSON}:</div>
                        <div className="data-control">
                          <Section>
                            <Button
                              className="theme-blue btn-width-auto"
                              disabled={false}
                              onClick={() => {
                                this.onClickInviteSupplier()
                              }}
                            >
                              Invite Supplier
                            </Button>
                          </Section>

                          <Section className="data">
                            <Table className="contact-detail">
                              <Table.TBODY>
                                {this.renderContactPersonList(supplierInfo)}
                              </Table.TBODY>
                            </Table>
                          </Section>
                        </div>
                      </Section>

                      {/* --------------------------
                      Tag Relevant:
                      ----------------------------*/}
                      <Section className="detail-group tag-relevant">
                        <div className="label">{STRING.TAG_RELEVANT}:</div>
                        <div className="data-control">
                          <div className="data-input tag-relevant">
                            <DebounceInput
                              // onKeyDown={this._relevantTagAdd.bind(this)}
                              id="tag_relevant"
                              className="tag-relevant"
                              type="text"
                              value={this.state.textRelevant}
                              onChange={e => {
                                if (this._isMounted) {
                                  return this.setState({
                                    textRelevant: e.target.value,
                                  })
                                }
                              }}
                              debounceTimeout={500}
                              element={Input}
                            />

                            <Button
                              className="theme-blue btn-width-auto"
                              onClick={() => {
                                this.onClickTagAdd(this.state.textRelevant)
                              }}
                            >
                              Add
                            </Button>
                          </div>

                          <div className="data">
                            <Section className="search-tags">
                              {this.renderRelevantTag(supplierInfo)}
                            </Section>
                          </div>
                        </div>
                      </Section>

                      <Section className="detail-group offline-comprehensive-assessment-score">
                        <div className="label">
                          {STRING.OFFLINE_COMPREHENSIVE_ASSESSMENT_SCORE}:
                        </div>

                        <div className="data-control">
                          <div className="data w-10">
                            {supplierInfo.offline_assessment}
                          </div>

                          <Button
                            className="theme-blue btn-comprehensive-score"
                            onClick={() => {
                              this.toggleModal(
                                'updateOfflineComprehensiveAssessment'
                              ),
                                document.body.classList.add('modal-open')
                            }}
                          >
                            Update Score
                          </Button>

                          {supplierInfo.offline_assessment === 'Yes' &&
                            supplierInfo.offline_assessment_add_date && (
                              <div className="data align-items-center">
                                Add date:{' '}
                                {dateMonDayYearTime(
                                  supplierInfo.offline_assessment_add_date
                                )}
                              </div>
                            )}
                        </div>
                      </Section>

                      <Section className="detail-group offline-comprehensive-assessment-score">
                        <div className="label">
                          {STRING.ONLINE_COMPREHENSIVE_ASSESSMENT_SCORE}:
                        </div>

                        <div className="data-control">
                          <div className="data w-10">
                            {supplierInfo.online_assessment}
                          </div>

                          {supplierInfo.company_type === 'Corporate' &&
                            supplierInfo.status_supplier === 1 &&
                            supplierInfo.have_online_template && (
                              <Button
                                className="theme-blue btn-comprehensive-score"
                                onClick={() => {
                                  this.onSendEmailOnlineTemplate()
                                }}
                              >
                                Request
                              </Button>
                            )}

                          {supplierInfo.online_assessment_request_date && (
                            <div className="data align-items-center">
                              Request date:{' '}
                              {dateMonDayYearTime(
                                supplierInfo.online_assessment_request_date
                              )}
                            </div>
                          )}
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.INVITATION_DATE}:</div>

                        <div className="data-control">
                          <div className="data">
                            {this.renderInvitationDate(supplierInfo)}
                          </div>
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.REGISTERED_DATE}:</div>

                        <div className="data-control">
                          <div className="data">
                            {this.renderRegisteredDate(supplierInfo)}
                          </div>
                        </div>
                      </Section>

                      <Section className="detail-group">
                        <div className="label">{STRING.ACTIVE}:</div>

                        <Section className="data-control">
                          <Switcher
                            onChange={this.onClickActive}
                            checked={isActive}
                          />
                          {this.renderActiveToggle(supplierInfo)}
                        </Section>
                      </Section>
                    </Section>
                  </Section>
                </Section>

                <Section className="form-actions">
                  <Section className="button-group">
                    {removeSuppilerActive && (
                      <Button
                        className="theme-blue btn-width-auto remove"
                        onClick={() => this.toggleModal('confirm')}
                      >
                        Delete Supplier
                      </Button>
                    )}
                  </Section>

                  <Section className="button-group">
                    <Button
                      className="theme-border-gray"
                      onClick={() => this.goBack()}
                    >
                      Cancel
                    </Button>

                    <Button
                      className="theme-green"
                      onClick={() => {
                        if (this._isMounted) {
                          return this.setState({ isLoading: true }, this.save)
                        }
                      }}
                      disabled={!this.state.buttonSaveActive}
                    >
                      Save
                    </Button>
                  </Section>
                </Section>
              </Section>
            </Section>

            {/* use same warning popup to pop message */}
            {supplierInfo.status_account === 2 ? (
              <Modal
                id="popup_warning_modal"
                className="popup warning theme-yellow"
                isOpen={isModalWarningIsOpen}
              >
                <Modal.Header>{supplierInfo.company_name}</Modal.Header>

                <Modal.Body>
                  <Image src={ICONS['icon-warning.svg']} className="warning" />

                  <div className="warning-msg">{supplierInfo.warning}</div>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    id="cancel_request_esg_modal"
                    className="theme-border-gray close"
                    onClick={() => this.modal.popupWarningToggle()}
                  >
                    {STRING.CLOSE}
                  </Button>
                </Modal.Footer>
              </Modal>
            ) : null}
          </SupplierManagementInformationEditStyle>

          {/* ACTIVE*/}
          <Modal
            id="reject_supplier_id"
            className="theme-blue modal-reject-supplier"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'inactiveSupplier'
                })
                .map(obj => obj.isOpen)[0]
            }
            modalWidth="768px"
          >
            <Modal.Header>Inactive Supplier</Modal.Header>
            <Modal.Body>
              <Section className="form-group">
                <label>Tax ID:</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper text">
                    {supplierInfo.tax_id}
                  </Section>
                </Section>
              </Section>

              <Section className="form-group">
                <label>Supplier Name:</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper text">
                    {supplierInfo.company_name}
                  </Section>
                </Section>
              </Section>

              <Section
                className={`form-group
             ${this.state.isValidateReason && 'is-error'}`}
              >
                <label>Reason:</label>

                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <InputTextarea
                      className="reason"
                      onChange={e => {
                        this.onChangeReason(e)
                      }}
                    />
                  </Section>
                  <Section className="message">
                    {this.state.isValidateReason && 'This field is required'}
                  </Section>
                </Section>
              </Section>
            </Modal.Body>

            <Modal.Footer>
              <Button
                id="close_modal_history_id"
                className="theme-border-gray"
                onClick={() => {
                  this.toggleModal('inactiveSupplier'),
                    document.body.classList.remove('modal-open')
                }}
              >
                Cancel
              </Button>

              <Button
                id="close_modal_history_id"
                className="theme-green"
                onClick={() => {
                  this.handleChange(),
                    document.body.classList.remove('modal-open')
                }}
              >
                Ok
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Confirm */}
          <Modal
            className="theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'confirm'
                })
                .map(obj => obj.isOpen)[0]
            }
            modalWidth="575px"
          >
            <Modal.Header>Confirm</Modal.Header>

            <Modal.Body>
              <p className="default text-center">
                Are you sure to delete supplier? <br />
                {supplierInfo.company_name}
              </p>
            </Modal.Body>

            <Modal.Footer>
              <Button
                className="theme-border-gray"
                onClick={() => {
                  this.toggleModal('confirm'),
                    document.body.classList.remove('modal-open')
                }}
              >
                Cancel
              </Button>

              <Button
                className="theme-green"
                onClick={() => this.removeSuppiler()}
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Invite Supplier */}
          <Modal
            className="invite-supplier theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'inviteSupplier'
                })
                .map(obj => obj.isOpen)[0]
            }
          >
            <Modal.Header>Invite Supplier</Modal.Header>

            <Modal.Body>
              <Section
                className="form-wrapper"
                style={{ width: '100%', maxWidth: 'unset' }}
              >
                <Section className="form-group">
                  <label>Tax ID</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Input type="text" value={supplierInfo.tax_id} readOnly />
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>

                <Section className="form-group">
                  <label>Company Name</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Input
                        type="text"
                        value={supplierInfo.company_name}
                        readOnly
                      />
                    </Section>

                    <Section className="message"></Section>
                  </Section>
                </Section>

                <Section
                  className={`form-group ${
                    isValidateFormContactName && 'is-error'
                  }`}
                >
                  <label>Full Name</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Input
                        type="text"
                        value={formContact.name}
                        onChange={e => {
                          formContact.name = e.target.value
                          if (this._isMounted) {
                            this.setState({
                              formContact,
                              isValidateFormContactName: false,
                              ErrMessageName: '',
                            })
                          }
                        }}
                      />
                    </Section>

                    <Section className="message">{ErrMessageName}</Section>
                  </Section>
                </Section>

                <Section
                  className={`form-group ${
                    isValidateFormContactEmail && 'is-error'
                  }`}
                >
                  <label>Email</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <Input
                        type="text"
                        value={formContact.email}
                        onChange={e => {
                          formContact.email = e.target.value
                          if (this._isMounted) {
                            this.setState({
                              formContact,
                              isValidateFormContactEmail: false,
                              ErrMessageEmail: '',
                            })
                          }
                        }}
                      />
                    </Section>

                    <Section className="message">{ErrMessageEmail}</Section>
                  </Section>
                </Section>

                <Section
                  className={`form-group ${
                    isValidateFormContactPhone && 'is-error'
                  }`}
                >
                  <label>Phone</label>

                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper ">
                      <Input
                        type="text"
                        value={formContact.phone}
                        onChange={e => {
                          formContact.phone = e.target.value
                          if (this._isMounted) {
                            this.setState({
                              formContact,
                              isValidateFormContactPhone: false,
                              ErrorMessage: '',
                            })
                          }
                        }}
                      />
                    </Section>
                    <Section className="message">
                      {isValidateFormContactPhone
                        ? this.state.validateFormContactErrorText.phone
                          ? this.state.validateFormContactErrorText.phone
                          : STRING.INVALID
                        : ''}
                    </Section>
                  </Section>
                </Section>
              </Section>
            </Modal.Body>

            <Modal.Footer>
              {isEditContact && (
                <Section>
                  <Button
                    className="theme-blue close"
                    onClick={() => this.onClickCancalInvitel(formContact.index)}
                  >
                    Cancel Invite
                  </Button>
                </Section>
              )}
              <Section className="justify-content-end">
                <Button
                  className="theme-border-gray close"
                  onClick={() => this.onCloseContact()}
                >
                  Cancel
                </Button>

                <Button
                  className="theme-green save"
                  isDisable={this.state.isInvite}
                  onClick={() => {
                    if (!this.state.isInvite) {
                      if (isEditContact) {
                        this.onEditContact(formContact.index)
                      } else {
                        this.onSaveContact()
                      }
                    }
                  }}
                >
                  Ok
                </Button>
              </Section>
            </Modal.Footer>
          </Modal>

          {/* Update Offline Comprehensive Assessment */}
          {this.renderUpdateScoreForm(modals, supplierInfo)}
        </React.Fragment>
      </React.Fragment>
    )
  }
}
const mapStateToProps = state => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}
export const SupplierManagementInformationEditContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SupplierManagementInformationEdit)
